<template>
    <img :src="`${bookInfoState.publicPath}/${annot.imgSrc}`"
         :style="data.styleHint"
         class="hint"
         :class="data.classHint"
         ref="refImg"
    >
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import cssvar from '@/scss/_variables.scss';
    import config from "@/config/config.json";

    const colorRect = cssvar.colorRect;
    const zIndexHint = parseInt(cssvar.zIndexHint);
    const zIndexBtnAnnotation = parseInt(cssvar.zIndexBtnAnnotation);
    const {getResizedAnnotationPos} = useAnnotationHelper();

    export default {

        props: {
            annot:Object,
            pagenum:Number,
            sharedMeta:Array
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState} = useBookInfo();
            const { pageResizeState} = usePageResize();
            const refImg = ref(null);

            const isShow = ref(props.annot.showAsDefault ? true: false);
            const hasAlphaPixels = ref(false);
            const zIndex = ref(0);

            console.log(props.annot.domPos)

            const data = reactive({
                pointerEvents:"none",
                isTransparencyRead:false, //tell whether the image transparency has been determined
                //maxHeight:"none",
                /*
                isShow:computed(()=>{

                    if (!bookInfoState.toggleHintsStatus[props.pagenum]) {
                        bookInfoState.toggleHintsStatus[props.pagenum] = {};
                    }

                    if (bookInfoState.toggleHintsStatus[props.pagenum][props.annot.id] === undefined) {

                        if (props.annot.showAsDefault) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return  bookInfoState.toggleHintsStatus[props.pagenum][props.annot.id];
                    }
                }),*/
                styleHint:computed(()=>{
                    let domPos = props.annot.domPos;
                    let translateX = "0px";
                    let translateY = "0px";
                    let transform;
                    let resizedDomPos = getResizedAnnotationPos(domPos);
                    data.height = resizedDomPos.height;

                    //fixed 2px displacement problem...
                    if (domPos.left < 0) {
                        //translateX = "2px"
                    }

                    transform = ` translate(${translateX}, ${translateY})`;

                    //note that height is set auto to prevent stretching; generally, if the hint is in "vertical mode", i.e. width < height,
                    //or if it is very close to "landscape mode" (see setHeightUpperRatio), height should be set,
                    //otherwise, leave it unset (height = "auto") and it will be scaled using the longer side, that is the width
                    return {
                        ...resizedDomPos,
                        display: isShow.value ? "block" : "none",
                        height: (props.annot.domPos.width / props.annot.domPos.height >= config.reader.hint.setHeightUpperRatio) ? "auto": data.height,
                        //maxHeight: data.maxHeight,
                        zIndex: zIndex.value,
                        pointerEvents:data.pointerEvents,
                        transform:`${transform}`,
                    }
                }),
                /**
                 * Use for counting how many visible hints on the current page, so that the current hint layer can be set to highest,
                 * if it is non-transparent
                 */
                classHint:computed(()=>{
                    return {
                        "active" : isShow.value
                    }
                }),
                mappedId:computed(()=>{
                    for (let item of props.sharedMeta) {
                        if (item.targetRectId === props.annot.id) {
                            return item.id;
                        }
                    }
                }),
                imgNaturalHeight:0
            });

            /**
             * Update the current hint layer by setting z-index
             * If the hint is transparent, it must not block other elements so set it to 1.
             * Otherwise, make it the highest layer by adding the base zIndex (since it should be on top of annotation buttons, so it has some value) to the total visible hint count
             */
            const setLayerOrder = ()=>{

                if (isShow.value) {

                    if (hasAlphaPixels.value) {
                        if (bookInfoState.hintOrderTransparent[props.pagenum] === undefined) {
                            bookInfoState.hintOrderTransparent[props.pagenum] = [];

                        }

                        bookInfoState.hintOrderTransparent[props.pagenum].push(props.annot.id);

                        let index = bookInfoState.hintOrderTransparent[props.pagenum].indexOf(props.annot.id);

                        if (bookInfoState.hintOrderTransparent.length > 1) {
                            bookInfoState.hintOrderTransparent.unshift(bookInfoState.hintOrderTransparent.splice(index, 1)[0]);
                        }


                        console.log("bookInfoState.hintOrderTransparent[props.pagenum]");
                        console.log(bookInfoState.hintOrderTransparent[props.pagenum])
                    } else {

                        if (bookInfoState.hintOrderSolid[props.pagenum] === undefined) {
                            bookInfoState.hintOrderSolid[props.pagenum] = [];
                        }

                        bookInfoState.hintOrderSolid[props.pagenum].push(props.annot.id);

                        let index = bookInfoState.hintOrderSolid[props.pagenum].indexOf(props.annot.id);

                        if (bookInfoState.hintOrderTransparent.length > 1) {
                            bookInfoState.hintOrderSolid.unshift(bookInfoState.hintOrderSolid.splice(index, 1)[0]);
                        }

                        console.log("bookInfoState.hintOrderSolid[props.pagenum]");
                        console.log(bookInfoState.hintOrderSolid[props.pagenum])
                    }
                } else {

                    if (hasAlphaPixels.value) {
                        if (bookInfoState.hintOrderTransparent[props.pagenum] !== undefined) {
                            let removeIndex = bookInfoState.hintOrderTransparent[props.pagenum].indexOf(props.annot.id);
                            bookInfoState.hintOrderTransparent[props.pagenum].splice(removeIndex, 1);

                            console.log("bookInfoState.hintOrderTransparent[props.pagenum]");
                            console.log(bookInfoState.hintOrderTransparent[props.pagenum])
                        }
                    } else {
                        if (bookInfoState.hintOrderSolid[props.pagenum] !== undefined) {
                            let removeIndex = bookInfoState.hintOrderSolid[props.pagenum].indexOf(props.annot.id);
                            bookInfoState.hintOrderSolid[props.pagenum].splice(removeIndex, 1);

                            console.log("bookInfoState.hintOrderSolid[props.pagenum]");
                            console.log(bookInfoState.hintOrderSolid[props.pagenum])
                        }
                    }
                }

                if (hasAlphaPixels.value) {

                    if ( bookInfoState.hintOrderTransparent[props.pagenum]) {
                        let index = bookInfoState.hintOrderTransparent[props.pagenum].indexOf(props.annot.id);
                        zIndex.value = zIndexHint + index;
                    }
                } else {

                    if (bookInfoState.hintOrderSolid[props.pagenum]) {
                        let index = bookInfoState.hintOrderSolid[props.pagenum].indexOf(props.annot.id);

                        //tricky: adding all hint count will make sure solid layer zIndex must be higher than transparent hint z-index
                        zIndex.value = zIndexHint +document.querySelectorAll(`#annotation-container-${props.pagenum} .hint`).length + index;
                    }
                }

            }


            watchEffect(() => {

                if (!bookInfoState.toggleHintsStatus[props.pagenum]) {
                    bookInfoState.toggleHintsStatus[props.pagenum] = {};
                }


                if (bookInfoState.toggleHintsStatus[props.pagenum][data.mappedId] === undefined) {
                    if (props.annot.showAsDefault) {
                        isShow.value = true;
                        bookInfoState.toggleHintsStatus[props.pagenum][data.mappedId] = true;
                    } else {
                        isShow.value = false;
                    }
                } else {
                    isShow.value = bookInfoState.toggleHintsStatus[props.pagenum][data.mappedId];
                }
            })


            onMounted(()=>{

                //set layer order after page turn and return
                if (isShow.value) {
                    setLayerOrder();
                }
            })

            watch(()=> isShow.value,
                async (newValue, oldValue) => {

                    //When there is hint order update, each hint will react to the change so that the zIndex of each hint can be updated accordingly


                    //if the hint is to be shown:
                    if (newValue === true) {


                        //if the image is not png type, it may not always contain transparency pixels. (solid image can also be saved to png type),
                        //so check the alpha pixel to see if it is transparent or not:
                        if (props.annot.imgSrc.indexOf(".png") >= 0) {
                            //Check if the hint image contains transparency, if yes, toggle hint buttons that are covered by it should be clickable;
                            //Otherwise, the hint image should block those buttons from being clicked. This is done by setting CSS pointer-events
                            //Set isTransparencyRead to indicate if transparency has been determined or not, so no need to check again next time
                            if (!data.isTransparencyRead) {
                                let copy = document.createElement('canvas');
                                let copyCtx = copy.getContext('2d');
                                let img = new Image();
                                const imageLoadPromise = new Promise(resolve => {
                                    img = new Image();
                                    img.onload = resolve;
                                    img.src = refImg.value.src;
                                });

                                await imageLoadPromise;
                                copyCtx.drawImage(img, 0, 0, img.width, img.height);

                                data.imgNaturalHeight = img.naturalHeight;

                                let imgData = copyCtx.getImageData(0, 0, copy.width, copy.height).data;
                                for (let i = 3, n = imgData.length; i < n; i += 4) {
                                    if (imgData[i] < 255) {
                                        hasAlphaPixels.value = true;
                                        break;
                                    }
                                }

                                data.isTransparencyRead = true;

                                setLayerOrder();
                                console.log("SHOW! zIndex.value; " + zIndex.value + "; transparent? " + hasAlphaPixels.value);

                                //if isTransparencyRead is true, determine transparency by checking hasAlphaPixels directly instead:
                            } else {
                                setLayerOrder();
                                console.log("SHOW! zIndex.value; " + zIndex.value + "; transparent? " + hasAlphaPixels.value);
                            }

                            //then the hint must be a solid (i.e. non-transparent) image
                        } else {
                            setLayerOrder();
                            console.log("SHOW! zIndex.value; " + zIndex.value + "; transparent? " + hasAlphaPixels.value);
                        }


                        if (hasAlphaPixels.value) {
                            //setting pfointer-events to none will make the toggle hint buttons behind clickable
                            data.pointerEvents = "none"
                        } else {
                            //setting pointer-events to none will prevent the toggle hint buttons behind from being clicked.
                            data.pointerEvents = "auto"
                        }

                        //Avoid hint stretching. There are a few cases that the annotation height is much taller than the actual image height.
                        //Set the image natural height (i.e. the actual height) to the annotation rect so that it won't be stretched.
                        //See the imgHeightDiffTolerance property in config file, telling how many pixels difference is considered too much stretched.
                        //nextTick(()=>{
                        /*
                        if (data.maxHeight !== "none") {
                            return;
                        }
                        if ((parseFloat(data.height) / pageResizeState.imgToBrowserScale) - config.reader.annot.imgHeightDiffTolerance > data.imgNaturalHeight / 2
                        ) {
                            data.maxHeight = (data.imgNaturalHeight / 2) * pageResizeState.imgToBrowserScale;
                        }*/

                        //if the hint is to be hidden, just update the layer order directly
                    } else {


                        setLayerOrder();
                        console.log("HIDE! hint count now: " + " ; " + "zIndex.value; " + zIndex.value + " ; transparent? " + hasAlphaPixels.value);



                    }

                }
            )


            return {
                data,
                isShow,
                refImg,
                hasAlphaPixels,
                pageResizeState,
                bookInfoState,
                parserState,
                getResizedAnnotationPos
            }

        }
    }

</script>


<style scoped lang="scss">

    .hint {
        pointer-events:none;
        position:absolute;
    }


</style>
